import { useState, useEffect } from 'react';
import { getCorporations } from '../api/services/common.service';

const defaultSelectOption = { ID: "000000000000000000000000000000000000", Name: "--Select--" };
const allSelectOption = { ID: "000000000000000000000000000000000000", Name: "--ALL--" };

export const useFetchCorporations = (corpIdFromUrl, { includeAll = false, includeSelect = true } = {}) => {
    const [corporations, setCorporations] = useState([]);
    const [selectedCorp, setSelectedCorp] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const fetchCorps = async () => {
            setLoading(true);
            setError(null);
            try {
                const corpsData = await getCorporations();
                if (cancelled) return;

                const formattedCorps = (corpsData || []).map(c => ({ ID: c.ID, Name: c.Name }));
                
                const options = [];
                if (includeSelect) options.push(defaultSelectOption);
                if (includeAll) options.push(allSelectOption);
                options.push(...formattedCorps);

                setCorporations(options);

                let initialSelection = null;
                if (corpIdFromUrl) {
                    initialSelection = options.find(c => c.ID.toLowerCase() === corpIdFromUrl.toLowerCase()) || null;
                }
                
                if (!initialSelection) {
                    initialSelection = includeAll ? allSelectOption : (includeSelect ? defaultSelectOption : null);
                }

                setSelectedCorp(initialSelection);

            } catch (err) {
                if (!cancelled) {
                    console.error("Error fetching corporations", err);
                    setError('Failed to load corporations.');
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        fetchCorps();

        return () => {
            cancelled = true;
        };
    }, [corpIdFromUrl, includeAll, includeSelect]);

    return { corporations, selectedCorp, setSelectedCorp, loading, error };
};

